var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card content-panel" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _vm.editorVisible
              ? _c("div", { staticClass: "row align-items-center" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group col-auto" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedReason,
                            expression: "selectedReason",
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "is-invalid": _vm.errors.has("inquiryReasonInput"),
                        },
                        attrs: {
                          id: "inquiryReasonInput",
                          name: "inquiryReasonInput",
                          "data-vv-as": '"Reason of Chatting"',
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedReason = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function ($event) {
                              return _vm.onInquiryReasonChange()
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("- Select -"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.inquiryReasons, function (reason) {
                          return _c("option", { domProps: { value: reason } }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(reason.name) +
                                "\n                        "
                            ),
                          ])
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("inquiryReasonInput"),
                            expression: "errors.has('inquiryReasonInput')",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [_vm._v(_vm._s(_vm.errors.first("inquiryReasonInput")))]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("PetDetails", {
              attrs: {
                visible: _vm.serviceId && _vm.petDetailsVisible,
                serviceId: _vm.serviceId,
                servicePathId: _vm.servicePathId,
                startChatVisible: _vm.startChatVisible,
                requestCallbackVisible: _vm.requestCallbackVisible,
                headers: _vm.headers,
              },
              on: {
                dataReadFailure: _vm.dataReadFailure,
                hideEditor: _vm.hideEditor,
              },
            }),
            _vm._v(" "),
            _c("NonHealthService", {
              attrs: {
                visible: _vm.serviceId && _vm.nonHealthMessageVisible,
                message: _vm.nonHealthMessage,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("v-modalPopup", {
        attrs: {
          bus: this,
          namespace: "alertModal",
          visible: _vm.alertVisible,
        },
        on: { close: _vm.hideAlert },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "label-large" }, [
        _vm._v("What would you like to chat about today"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }